import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Button } from 'semantic-ui-react'
import Modal from 'react-modal'
import PreviewResizer from '../components/PreviewResizer'
import PreviewSelector from '../components/PreviewSelector'
import ContactForm from '../components/ContactForm'
import logo from '../assets/images/logo.svg'
import flagEl from '../assets/images/flag-el.png'
import flagEn from '../assets/images/flag-en.png'
import {media} from '../style/utils'

class Header extends Component {
  static propTypes = {
    items: PropTypes.array,
    previewMode: PropTypes.string,
    setPreviewMode: PropTypes.func,
  }

  constructor () {
    super()
    this.state = {
      showModal: false,
    }

    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    Modal.setAppElement('#root')
  }

  openModal() {
    this.setState({ showModal: true })
  }

  closeModal() {
    this.setState({ showModal: false })
  }

  render() {
    const { t, i18n, location, history, items, previewMode, setPreviewMode } = this.props

    const isHome = location.pathname === '/'
    const isPreview = location.pathname.includes('/preview')
    const previewName = isPreview && location.pathname.replace('/preview/', '').replace('/', '')

    const changeLanguage = (lang) => {
      i18n.changeLanguage(lang)
      document.querySelector('html').setAttribute('lang', lang)
    }

    return (
      <StyledHeader className={isHome ? 'transparent' : 'solid'}>
        <div className="logo"><Link to="/"><img src={logo} alt="Ron"/></Link></div>
        {isHome &&
          <Fragment>
            {i18n.language === 'en' && <button onClick={() => changeLanguage('el')}><img src={flagEl} alt="Ελληνικά" /></button>}
            {i18n.language === 'el' && <button onClick={() => changeLanguage('en')}><img src={flagEn} alt="English" /></button>}
          </Fragment>
        }
        {isPreview &&
          <Fragment>
            <PreviewSelector items={items} name={previewName} history={history} />
            <PreviewResizer mode={previewMode} setMode={setPreviewMode}/>
            <Button basic inverted onClick={this.openModal}>{t('Request it')}</Button>
            {/*<Modal dimmer open={this.state.showModal} onClose={this.closeModal}>
              <Modal.Header>Select a Photo</Modal.Header>
              <Modal.Content image>
                <Image wrapped size='medium' src='/assets/images/avatar/large/rachel.png' />
                <Modal.Description>
                  <Header>Default Profile Image</Header>
                  <p>We've found the following gravatar image associated with your e-mail address.</p>
                  <p>Is it okay to use this photo?</p>
                </Modal.Description>
              </Modal.Content>
              <Modal.Actions>
                <Button color='black' onClick={this.closeModal}>Nope</Button>
                <Button positive icon='checkmark' labelPosition='right' content="Yep, that's me" onClick={this.closeModal} />
              </Modal.Actions>
            </Modal>*/}
            <Modal isOpen={this.state.showModal} contentLabel={t('Website request form')}
              onRequestClose={() => { this.setState({ showModal: false }) }} className="ui modal visible transition"
              style={{overlay: {backgroundColor: 'rgba(0,0,0,.95)'}, content: {top: '48px', maxHeight: 'calc(100vh - 56px)', overflow: 'auto'}}}>
              <div className="header">{t('Website request form')}</div>
              <div className="image content">
                <div className="ui medium image" style={{overflow: 'hidden', maxHeight: '50vh'}}>
                  <img src={`${process.env.REACT_APP_API_URL}/screenshots/${previewName}.jpg`} alt={t('Selected template image')} />
                </div>
                <div className="description">
                  <ContactForm previewName={previewName}/>
                </div>
              </div>
              <div className="actions">
                <Button color='black' onClick={this.closeModal} content={t('Cancel')} />
                <Button positive icon='checkmark' labelPosition='right' content={t('Submit')} type="submit" form="website-form" />
              </div>
            </Modal>
          </Fragment>
        }
      </StyledHeader>
    )
  }
}

const StyledHeader = styled.header`
  button {
    float: right;
    margin-top: 4px;
    cursor: pointer;
  }
  &.transparent {
    position: fixed;
    z-index: 0;
    width: 90%;
    padding: 6px 5%;
    & > .logo {
      display: inline-block;
      img { height: 48px; margin-top: 1rem; }
    }
    button {
      padding: 0;
      border: 0;
      height: 24px;
      margin-top: 12px;
      opacity: .85;
      transition: opacity .25s;
      background: transparent;
      filter: saturate(0.5);
    }
    button:hover, button:focus { opacity: 1; filter: saturate(1); }
    button img { height: 100%; /*box-shadow: 0 0 1px 0 white;*/ }
  }
  &.solid {
    background: #222;
    padding: 3px 5%;
    height: 42px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    width: 100%;
    & > div, & > button {
      flex: 1;
      margin-left: 5% !important;
      margin-right: 5% !important;
      /* min-width: 150px; */
    }
    & > button {
      min-width: 135px;
    }
    & > button, & > .dropdown {
      max-width: 150px;
    }
    & > .dropdown input {
      color: white;
    }
    & > .dropdown i {
      position: absolute !important;
      margin-top: 2px !important;
    }
    & > .logo {
      min-width: 81px;
      max-width: 120px;
      img {
        height: 36px;
      }
    }

    @media (max-width: 1366px) {
      .buttons button:nth-of-type(1) { display: none !important; }
      .buttons button:nth-of-type(2) { border-top-left-radius: .28571429rem; border-bottom-left-radius: .28571429rem; }
    }
    @media (max-width: 1024px) {
      .buttons button:nth-of-type(2) { display: none !important; }
      .buttons button:nth-of-type(3) { border-top-left-radius: .28571429rem; border-bottom-left-radius: .28571429rem; }
    }
    @media (max-width: 640px) {
      .buttons { display: none !important; }
    }

    ${media.xs`
      .dropdown { display: none !important; }
    `};
  }

`

export default translate('tr')(withRouter(Header))



// WEBPACK FOOTER //
// ./src/layout/Header.jsx